import { BarChart3, Plus } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Card } from '@/shared/components/ui/card';
import { useTranslation } from 'react-i18next';

interface DashboardEmptyStateProps {
  onAddDashboard: () => void;
}

export const DashboardEmptyState = ({ onAddDashboard }: DashboardEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <Card className="flex flex-col items-center justify-center p-12 text-center min-h-[400px]">
      <div className="rounded-full bg-muted p-6 mb-4">
        <BarChart3 className="h-12 w-12 text-muted-foreground" />
      </div>
      <h3 className="text-xl font-semibold mb-2">{t('dashboards.noDashboards')}</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        {t('dashboards.noDashboardsDescription')}
      </p>
      <Button onClick={onAddDashboard} size="lg">
        <Plus className="mr-2 h-4 w-4" />
        {t('dashboards.addFirstDashboard')}
      </Button>
    </Card>
  );
};
